export const getUICompanyName = draft => {
  var _draft$contactDetails;
  return draft.isSample ? 'Anchor (Sample)' : ((_draft$contactDetails = draft.contactDetails) === null || _draft$contactDetails === void 0 ? void 0 : _draft$contactDetails.companyName) || '';
};